export default __webpack_public_path__ + "static/kundfaktura_banner-9d17135cd63da8629351270382ec7ebd.svg";